import React from 'react'
// import { Link } from "gatsby";
import { Heading } from 'components/Heading'
import { GatsbyImage } from 'gatsby-plugin-image'
import { Link } from 'components/Link'
import { Container, Row, Col } from 'components/Layout'
import { CallToAction, TrackedCTA } from 'components/CallToAction'
import { PricingCTA } from 'components/PricingCTA'
import SectionTitle from 'components/SectionTitle'
import { Button2 as Button } from 'components/Button'
import VintageBox from 'components/VintageBox'
import { prepareData } from 'utils/googleData'
import { FileSearchOutlined as FaMapMarkedAlt } from '@ant-design/icons'
import { CloudDownloadOutlined as FiDownloadCloud } from '@ant-design/icons'
// import Banner3SectionWrapper from "./banner3.style";
import { heading } from 'components/Home/classes'

export function Hero3(props) {
    const {
        enable,
        title,
        subtitle,
        Icon,
        description,
        cta,
        cta2,
        direction,
        bgColor,
        style,
        gatsbyImage,
        features,
        gatsbyTransformed,
        textColor = 'primary',
    } = prepareData({ props })
    if (enable?.toLowerCase?.() === 'false' && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    return (
        <section
            className={`mt-0 flex flex-col items-center p-20 pt-0 pb-0 transition-all lg:flex-row lg:justify-between ${style}`}
            direction={direction}
        >
            <div className="section-title-wrapper max-w-full">
                <SectionTitle className="section-title" leftAlign={true} UniWidth="100%">
                    {title && (
                        <h4 className="mt-2 text-[18px] font-semibold leading-tight text-primary opacity-75 lg:text-[20px]">
                            {title}
                        </h4>
                    )}
                    {subtitle && (
                        <h1
                            className="text-lg lg:text-xl xl:text-2xl"
                            dangerouslySetInnerHTML={{ __html: subtitle }}
                        ></h1>
                    )}
                </SectionTitle>
                {description && <p>{description}</p>}
                <VintageBox
                    right={true}
                    vintageOne={true}
                    className="flex flex-col space-y-2 sm:flex-row sm:space-y-0 sm:space-x-2"
                >
                    {cta?.url && (
                        <CallToAction
                            type="primary"
                            className="mx-2 my-0 inline-flex w-full items-center justify-center whitespace-nowrap rounded bg-gradient-to-r from-[#00b39f] to-[#00b39f] py-2 text-center font-medium uppercase !leading-none text-white outline-none transition-[colors,opacity] duration-200"
                            to={cta?.url}
                        >
                            <FaMapMarkedAlt size={21} className="icon-left" />
                            &nbsp;{cta?.text}
                        </CallToAction>
                    )}
                    {cta2?.url && (
                        <CallToAction
                            type="primary"
                            className="mx-2 my-0 inline-flex w-full items-center justify-center whitespace-nowrap rounded bg-gradient-to-r from-[#00b39f] to-[#00b39f] py-2 text-center font-medium uppercase !leading-none text-white outline-none transition-[colors,opacity] duration-200"
                            to={cta2?.url}
                        >
                            <FiDownloadCloud size={21} className="icon-left" />
                            &nbsp;{cta2?.text}
                        </CallToAction>
                    )}
                </VintageBox>
            </div>
            <div className="mt-10">
                {Icon && (
                    <div className="flex w-full justify-center lg:justify-start">
                        <Icon className="h-auto max-w-full" />
                    </div>
                )}
                {gatsbyImage && (
                    <GatsbyImage
                        image={gatsbyImage}
                        alt=""
                        objectFit="contain"
                        className="my-4 block h-auto max-w-full sm:my-6"
                    />
                )}
            </div>
        </section>
    )
}

export default Hero3
